import React, { FunctionComponent, PropsWithChildren, memo } from 'react';

import styles from './SelectItem.scss';

//----------------------------------------------------------------------
// COMPONENT
//----------------------------------------------------------------------

const SelectItem: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default memo(SelectItem);
